export default class WhitelabelView {
    constructor(json) {
        this.applicationTitle = json.applicationTitle;
        this.customColors = json.customColors;
        this.primaryColor = json.primaryColor;
        this.secondaryColor = json.secondaryColor;
        this.hoverColor = json.hoverColor;
        this.favicon = json.favicon;
        this.logo = json.logo;
        this.squaredLogo = json.squaredLogo;
        this.kioskBackgroundColor = json.kioskBackgroundColor;
    }
}
